import { CMS } from '../../constant/index'
import ReadmoreIcon from '../../icons/readmore-icon/index.vue'

export default {
  components: {
    ReadmoreIcon
  },

  setup() {
    
    const bgImage = (imgPath) => {
      return { backgroundImage: `url(${imgPath})` }
    }
    
    return {
      bgImage,
      CMS
    }
  }
}
